// Indonesian
export const id = {
    weeklyRewards: 'Hadiah mingguan dalam',
    days: 'hari',
    hours: 'jam',
    minutes: 'menit',
    seconds: 'dtk',
    authenticating: 'Mengautentikasi',
    verifyWallet: 'Mohon tunggu sementara kami memverifikasi dompet Anda',
    authRequired: 'Autentikasi diperlukan',
    authFailed: 'Autentikasi gagal. Silakan coba lagi.',
    points: 'Poin',
    rank: 'Peringkat',
    of: 'dari',
    players: 'pemain',
    weeklyTopPlayers: 'Pemain teratas minggu ini',
    thisWeekLeaderboard: 'Papan peringkat minggu ini',
    rankingsReset: 'Peringkat direset setiap Minggu pukul 00:00 UTC',
    yourPoints: 'Poin Anda',
    dailyRewardAvailable: 'Hadiah harian tersedia!',
    nextClaimAvailable: 'Klaim berikutnya tersedia dalam:',
    claimDailyReward: 'Klaim hadiah harian',
    claiming: 'Mengklaim...',
    multiplier: 'Pengali',
    bonusPointsMultiplier: 'Pengali poin bonus',
    outOf: 'dari',
    loading: 'Memuat...',
    errorLoading: 'Kesalahan saat memuat',
    noEntries: 'Tidak ada entri',
    leaderboard: 'Papan peringkat',
    tasks: 'Tugas',
    rules: 'Aturan',
    profile: 'Profil',
    comingSoon: 'Segera hadir...',
    completedTasks: 'Tugas selesai',
    dailyRewardsClaimed: 'Hadiah harian yang diklaim',
    times: 'kali',
    recentActivity: 'Aktivitas terbaru',
    noRewardsClaimed: 'Belum ada hadiah yang diklaim',
    dailyReward: 'Hadiah harian',
    howItWorks: 'Cara kerja',
    welcomeMessage:
        'Selamat datang di Coinomi Rewards! Dapatkan poin dengan menyelesaikan berbagai tugas dan naik di papan peringkat.',
    dailyRewardsTitle: 'Hadiah harian',
    dailyRewardsRules: [
        'Klaim hadiah harian Anda setiap 24 jam',
        'Setiap klaim memberikan 100 poin',
        'Poin dikalikan dengan pengali Anda',
    ],
    multiplierBonusesTitle: 'Bonus pengali',
    multiplierBonusesRules: [
        'Mulai dengan pengali 1x',
        'Hubungkan Telegram untuk bonus +10%',
        'Verifikasi email untuk bonus +10%',
        'Bonus bertumpuk untuk hadiah maksimal',
    ],
    leaderboardTitle: 'Papan peringkat',
    leaderboardRules: [
        'Bersaing dengan pemain lain',
        'Papan peringkat diperbarui secara real-time',
        'Pemain teratas menerima hadiah khusus',
    ],
    boostEarningsTitle: 'Tingkatkan pendapatan',
    boostEarningsRules: [
        'Selesaikan tantangan untuk bonus',
        'Bergabung dengan komunitas Telegram kami',
        'Tetap aktif untuk hadiah maksimal',
    ],
    challenges: 'Tantangan',
    telegramChallenge: 'Tantangan Telegram',
    emailChallenge: 'Tantangan Email',
    connectTelegram: 'Hubungkan Telegram',
    shareEmail: 'Bagikan email',
    telegramSuccess: '🎉 Selamat! Anda sekarang menerima bonus permanen 10% untuk semua hadiah!',
    telegramPrompt:
        'Hubungkan akun Telegram Anda untuk menerima bonus permanen 10% untuk semua hadiah!',
    emailSuccess: '🎉 Selamat! Anda sekarang menerima bonus permanen 10% untuk semua hadiah!',
    emailPrompt: 'Bagikan email Anda untuk menerima bonus permanen 10% untuk semua hadiah!',
    connectEmail: 'Hubungkan email',
    cancel: 'Batal',
    emailPrivacy:
        'Kami hanya menggunakan email Anda untuk pembaruan penting dan notifikasi hadiah.',
    connectYourEmail: 'Hubungkan email Anda',
    emailBonus:
        '🎉 Dapatkan bonus permanen 10% untuk semua hadiah dengan menghubungkan email Anda!',
    enterValidEmail: 'Silakan masukkan alamat email yang valid',
    emailAddress: 'Alamat email',
    errorSavingEmail: 'Kesalahan saat menyimpan email. Silakan coba lagi.',
    claimButton: 'Klaim',
    earnedReward: 'Hadiah yang diperoleh',
    rewardValue: '{{amount}} Poin',
    claimingReward: 'Mengklaim...',
    claimSuccess: 'Berhasil mengklaim {{amount}} poin!',
    claimError: 'Klaim gagal. Silakan coba lagi.',
    privacyDisclaimer:
        'Coinomi tidak mengumpulkan data pribadi; sistem pihak ketiga mengelola poin dan koneksi sosial secara aman.',
    streakBonus: 'Bonus beruntun',
    streakDays: '{{days}}/5 Hari',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Ekstra',
    streakDescription: 'Klaim 5 hari berturut-turut untuk bonus maksimal',
    streakToday: 'Hari ini',
    streakMissed: 'Terlewat',
    streakComplete: 'Selesai',
    streakActive: 'Beruntun aktif',
    streakLost: 'Beruntun hilang',
    streakNext: 'Berikutnya',
    home: 'Beranda',
    currentStreak: 'Beruntun saat ini',
    totalClaims: 'Total klaim',
    userStats: 'Statistik Anda',
    referrals: 'Referral',
    referralProgram: 'Program referral',
    howReferralWorks: 'Cara kerja referral:',
    referralSteps: [
        'Bagikan link referral Anda dengan teman',
        'Saat mereka bergabung melalui link Anda, mereka menjadi referral Anda',
        'Dapatkan poin bonus untuk setiap referral aktif',
        'Pantau referral dan pendapatan Anda di sini',
    ],
    referralRewards: 'Poin referral diberikan:',
    referralBonuses: ['100 poin per referral', '10% dari semua poin yang diperoleh referral Anda'],
    yourReferralLink: 'Link referral Anda',
    copyToClipboard: 'Salin ke clipboard',
    linkCopied: 'Link disalin ke clipboard!',
    totalReferrals: 'Total referral',
    yourReferralCode: 'Kode referral Anda',
    referralCodeCopied: 'Kode referral disalin!',
    editReferralCode: 'Edit kode referral',
    editReferralCodeInstructions:
        'Pilih kode referral baru. Harus minimal 5 karakter dan dapat berisi huruf dan angka.',
    newReferralCode: 'Kode referral baru',
    referralCodeRequirements: 'Minimal 5 karakter, hanya huruf dan angka',
    updating: 'Memperbarui...',
    update: 'Perbarui',
    referralCodeTaken: 'Kode referral ini sudah digunakan',
    haveReferralCode: 'Punya kode referral?',
    enterReferralCodePrompt:
        'Jika seseorang mereferensikan Anda, masukkan kode mereka di sini untuk menghubungkan akun.',
    enterReferralCode: 'Masukkan kode referral',
    enterReferralCodeInstructions: 'Masukkan kode referral yang dibagikan dengan Anda.',
    referralCode: 'Kode referral',
    referralCodeFormat: 'Hanya huruf dan angka',
    submitting: 'Mengirim...',
    submit: 'Kirim',
    enterCode: 'Masukkan kode',
    pleaseAddtoken: 'Silakan tambahkan parameter token ke URL',
    authenticationError: 'Terjadi kesalahan saat autentikasi',
    noUserFound: 'Tidak ada pengguna ditemukan',
    userNotFoundMessage: 'Data pengguna tidak dapat ditemukan',
    backToHome: 'Kembali ke beranda',
    retry: 'Coba lagi',
    baseMultiplier: 'Pengali dasar',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Tantangan referral',
    referralChallengePrompt:
        'Undang teman dan dapatkan poin bonus! Terima 100 poin untuk setiap referral plus 10% dari pendapatan mereka.',
    startReferring: 'Mulai mereferensikan',
    referralSuccess:
        '🎉 Selamat! Anda telah berhasil mereferensikan pengguna dan mendapatkan poin bonus!',
    unranked: 'Belum peringkat',
    noPlayersYet: 'Jadilah yang pertama bergabung!',
    shareVia: 'Bagikan melalui',
    shareOn: 'Bagikan di {{network}}',
    shareInviteText:
        '🚀 Saya mendapatkan crypto gratis dengan @CoinomiWallet!\n\nUnduh Coinomi di coinomi.com/downloads dan masukkan kode referral saya {{referralCode}} untuk mendapatkan bonus saat Anda bergabung dengan #Coinomi Rewards di aplikasi.',
    yourStatsThisWeek: 'Statistik Anda minggu ini',
    pointsMultiplier: 'Pengali poin',
    yourRank: 'Peringkat Anda',
    rewards: 'Hadiah',
    daily: 'Harian',
    weekly: 'Mingguan',
    claimRewards: 'Klaim hadiah',
    copy: 'Salin',
    // Twitter Challenge
    twitterChallenge: 'Tantangan Twitter',
    connectTwitter: 'Hubungkan Twitter',
    twitterSuccess: '🎉 Selamat! Anda sekarang menerima bonus permanen 10% untuk semua hadiah!',
    twitterPrompt:
        'Hubungkan akun Twitter Anda untuk mendapatkan bonus permanen 10% untuk semua hadiah!',
    pleaseAddUserId: 'Silakan tambahkan parameter userId ke URL',
    emailChallengePrompt:
        'Bagikan email Anda untuk mendapatkan bonus permanen 10% untuk semua hadiah!',
    emailChallengeSuccess:
        '🎉 Terhubung! Anda sekarang menerima bonus permanen 10% untuk semua hadiah!',
    followKoalaWalletChallenge: 'Ikuti @coinomiWallet di Twitter untuk mendukung kami!',
    twitterAuthSuccessTitle: 'Twitter Berhasil Terhubung!',
    twitterAuthSuccessMessage:
        'Anda telah berhasil menghubungkan akun Twitter Anda. Anda sekarang dapat melanjutkan menggunakan aplikasi.',
    continueToApp: 'Lanjutkan ke Aplikasi',
    twitter_like: 'Menyukai tweet',
    twitter_retweet: 'Me-retweet tweet',
    disconnect: 'Putuskan Koneksi',
    followCoinomiWallet: 'Ikuti @coinomiWallet di Twitter untuk mendukung kami!',
    connectedBonus: '🎉 Terhubung! Anda sekarang menerima bonus permanen 10% untuk semua hadiah!',
};
